export const DESIGNER_ORDER = 1
export const CHECK_ORDER = 2
export const INWORK_ORDER =3
export const READY_ORDER =4